import React, { useEffect, useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import timerRedSvg from '../../assets/img/timer-red.svg';
import timerGreenSvg from '../../assets/img/timer-green.svg';

const Timer = ({ expertiseEndedAt, startTime = null, finishTime = null, salesEndedAt = null }) => {
  const [counter, setCounter] = useState(null);
  const [timerUp, setTimerUp] = useState(false);
  const presentDate = moment();
  const icons = { true: timerRedSvg, false: timerGreenSvg };
  const interval = 1000;
  let intervalSync = null;
  const startHours = startTime && parseInt(startTime.split(':')?.[0], 10);
  const startMinutes = startTime && parseInt(startTime.split(':')?.[1], 10);

  const hours = finishTime && parseInt(finishTime.split(':')?.[0], 10);
  const minutes = finishTime && parseInt(finishTime.split(':')?.[1], 10);

  const newExpertiseEndedAt =
    expertiseEndedAt && moment(expertiseEndedAt).add(startHours, 'hours').add(startMinutes, 'minutes');
  const newSalesEndedAt = salesEndedAt && moment(salesEndedAt);

  const checkFinishTimer = (duration) => {
    if (duration.days() < -1 || (hours <= 23 && duration.days() === -1)) return false;
    if (
      (hours === 24 && duration.days() === -1 && duration.hours() <= 0) ||
      (hours <= 23 && duration.days() === 0 && duration.hours() <= -hours)
    ) {
      if (minutes > 0 && duration.minutes() < -minutes + 1) return false;
      if (minutes === 0 && duration.minutes() <= -minutes) return false;
    }
    return true;
  };

  useEffect(() => {
    if (newExpertiseEndedAt || newSalesEndedAt) {
      const date = newExpertiseEndedAt || newSalesEndedAt;
      intervalSync = setInterval(() => {
        const duration = moment.duration(moment(date).diff(presentDate));
        let timer = '';
        if (!timerUp) {
          if (duration.isValid() && duration.hours() >= 0 && duration.minutes() >= 0 && duration.seconds() >= 0) {
            if (duration.days() < 10) timer = `0${duration.days()}`;
            else timer = `${duration.days()}`;
            if (duration.hours() < 10) timer = timer.concat(`:0${duration.hours()}`);
            else timer = timer.concat(`:${duration.hours()}`);
            if (duration.minutes() < 10) timer = timer.concat(`:0${duration.minutes()}`);
            else timer = timer.concat(`:${duration.minutes()}`);
            if (duration.seconds() < 10) timer = timer.concat(`:0${duration.seconds()}`);
            else timer = timer.concat(`:${duration.seconds()}`);
            if (duration.days() === 0 && duration.hours() === 0 && duration.minutes() === 0 && duration.seconds() === 0)
              setTimerUp(true);
            return setCounter(timer);
          }
        }
        setTimerUp(true);
        if (newExpertiseEndedAt) {
          if (checkFinishTimer(duration)) {
            if (hours === 24 && duration.days() === -1 && duration.hours() === 0) timer = `-24`;
            else if (duration.hours() > -10) timer = `-0${duration.hours() * -1}`;
            else timer = `${duration.hours()}`;
            if (duration.minutes() > -10) timer = timer.concat(`:0${duration.minutes() * -1}`);
            else timer = timer.concat(`:${duration.minutes() * -1}`);
            if (duration.seconds() > -10) timer = timer.concat(`:0${duration.seconds() * -1}`);
            else timer = timer.concat(`:${duration.seconds() * -1}`);
            return setCounter(timer);
          }
          if (hours < 10) timer = `-0${hours}`;
          else timer = `-${hours}`;
          if (minutes < 10) timer = timer.concat(`:0${minutes}:00`);
          else timer = timer.concat(`:${minutes}:00`);
          return setCounter(timer);
        }
        return setCounter('00:00:00:00');
      }, interval);
    }
    return () => {
      clearInterval(intervalSync);
    };
  }, [newExpertiseEndedAt, newSalesEndedAt]);

  return (
    <div className={`timer-wrapper ${timerUp && 'text-danger'}`}>
      {counter && (
        <>
          <img src={icons[timerUp]} alt="timer" className="svg" />
          {counter}
        </>
      )}
    </div>
  );
};

Timer.propTypes = {
  expertiseEndedAt: PropTypes.string,
  startTime: PropTypes.string,
  finishTime: PropTypes.string,
  salesEndedAt: PropTypes.string,
};

Timer.defaultProps = {
  expertiseEndedAt: null,
  startTime: null,
  finishTime: null,
  salesEndedAt: null,
};

export default Timer;
